import { useLanguage } from "context/Translation";
import { FC, Fragment } from "react";

const PrivacyPolizyText: FC = () => {
  const { isRus } = useLanguage();
  return (
    <div>
      <h3>
        <b>
          {isRus
            ? "Положение об обработке персональных данных НИУ ВШЭ"
            : "Regulations on Personal Data Processing at National Research University Higher School of Economics"}
        </b>
      </h3>
      <br />
      <br />
      <h4>
        <b>1. {isRus ? "Общие положения" : "General Provisions"}</b>
      </h4>
      <br />
      &nbsp; 1.1.{" "}
      {isRus
        ? "При обработке персональных данных Национальный исследовательский университет «Высшая школа экономики» (далее – НИУ ВШЭ, университет) исходит из необходимости обеспечения защиты прав и свобод человека и гражданина в соответствии с требованиями законодательства Российской Федерации."
        : "Personal data processing at National Research University Higher School of Economics (hereafter, the “University”, or “HSE”) is organized in order to ensure personal human and civil rights, pursuant to the requirements of Russian legislation."}
      <br />
      <br />
      &nbsp; 1.2.{" "}
      {isRus
        ? "Соблюдение Положения является главным условием обработки персональных данных университетом и обязательно для всех работников НИУ ВШЭ."
        : "Personal data processing at the University shall be organized in strict compliance with these Regulations, which must be observed by all HSE staff."}
      <br />
      <br />
      &nbsp; 1.3.{" "}
      {isRus
        ? "Целью Положения является обеспечение защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну, определение политики НИУ ВШЭ как оператора в отношении обработки персональных данных. Положение регулирует отношения НИУ ВШЭ и граждан, возникающие в связи с обработкой их персональных данных университетом."
        : "These Regulations are aimed at ensuring protection of personal human and civil rights in the course of personal data processing, with respect to privacy policies, personal and family confidentiality, as well as setting forth the University’s policies as the personal data operator. Furthermore, these Regulations set forth relations between HSE and citizens arising as a result of personal data processing on the part of the University."}
      <br />
      <br />
      &nbsp; 1.4.{" "}
      {isRus
        ? "НИУ ВШЭ принимает правовые, организационные и технические меры, необходимые для обеспечения исполнения законодательства о персональных данных, либо обеспечивает их принятие."
        : "HSE hereby undertakes legal, organizational and technical measures required for ensuring the application of Russian legislation on personal data protection and/or ensures the adoption of such measures."}
      <br />
      <br />
      &nbsp; 1.5.{" "}
      {isRus
        ? "В Положение могут вноситься изменения без предварительного уведомления субъектов персональных данных и прочих лиц. Актуальная редакция Положения размещена на корпоративном сайте (портале) НИУ ВШЭ по адресу: "
        : "These Regulations may be amended without prior notification of the personal data subjects and other persons. The current version of the Regulations may be viewed on HSE’s corporate website (portal) at"}{" "}
      <a href="https://www.hse.ru/data_protection_regulation">
        https://www.hse.ru/data_protection_regulation
      </a>
      <br />
      <br />
      &nbsp; 1.6.{" "}
      {isRus
        ? "Положение и изменения в него утверждаются приказом ректора НИУ ВШЭ."
        : "These Regulations and amendments thereto shall be approved by a directive issued by HSE’s Rector."}
      <br />
      <br />
      <h4>
        <b>2. {isRus ? "Термины и определения" : "Terms and Definitions"}</b>
      </h4>
      <br />
      &nbsp; 2.1.{" "}
      {isRus
        ? "Термины и определения, используемые в Положении, приведены в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее – ФЗ «О персональных данных») и иными нормативными правовыми актами Российской Федерации, а именно:"
        : "The terms and definitions used in these Regulations are presented as per Federal Law No. 152-FZ, dated July 27, 2006 (hereafter, the “Federal Law On Personal Data”) and other bylaws of the Russian Federation, as follows:"}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.1.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>персональные данные (далее – ПДн) </i>
          </b>
          – любая информация, относящаяся к прямо или косвенно определенному или
          определяемому физическому лицу (субъекту ПДн). ПДн и их категории
          могут различаться по степени определенности и определимости субъекта
          ПДн и зависят от действительной возможности определения на их основе
          конкретного человека и гражданина (субъекта). Данные, не определяющие
          личность человека и гражданина, или не позволяющие определить такую
          личность даже с применением каких-либо процедур[1], не являются ПДн, а
          их обработка не связана с необходимостью соблюдения законодательства
          Российской Федерации о ПДн. К указанным данным могут относится такие
          популярные сведения, как пол, возраст, должность[2], профессия, хобби
          и пр., и сведения, появляющиеся в связи с повсеместным проникновением
          сети Интернет в повседневную жизнь[3], до тех пор, пока такие сведения
          не позволяют установить личность человека и гражданина;
        </Fragment>
      ) : (
        "Personal data (hereafter, “PD”) includes information, directly or indirectly relating to any particular individual (hereinafter, a “PD Subject”). PD and related categories thereof may differ in terms of a given PD Subject’s identification and identifiability, as well as depend on whether or not a particular person or citizen (PD Subject) can be identified on the basis of relevant PD. Any data that does not feature information on personal identity, or does not make it possible to identify persons by use of special procedures[1], shall not be considered PD. Thus, such information may be processed regardless of Russian legislation on PD processing. Such data can include such common information as gender, age, official position[2], profession, hobby, etc., as well as information generally available through Internet[3], until such data may allow the identification of a person or citizen;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.2.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>псубъекты ПДн </i>
          </b>
          – определенные или определяемые (поддающиеся определению) физические
          лица. К числу таких лиц могут относиться работники, абитуриенты,
          обучающиеся и выпускники НИУ ВШЭ, участники олимпиад и других
          мероприятий, проводимых университетом, и иные лица;
        </Fragment>
      ) : (
        "PD Subjects are identifiable individuals. Such persons may include HSE staff, applicants, students and alumni, participants in HSE Olympiads, and other events hosted by the University, as well as other persons;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.3.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>работник </i>
          </b>
          – физическое лицо, вступившее в трудовые отношения с университетом;
        </Fragment>
      ) : (
        "An employeeis an individual working at the University;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.4.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>обучающийся </i>
          </b>
          – физическое лицо, осваивающее образовательную программу. Для целей
          Положения к обучающимся относятся также физические лица, приобретающие
          какие-либо знания, умения и навыки, формирующие компетенции,
          удовлетворяющие свои образовательные потребности в интеллектуальном,
          духовно-нравственном, физическом и (или) профессиональном
          совершенствовании в иной форме, а также абитуриенты;
        </Fragment>
      ) : (
        "A student is an individual studying under an HSE educational programme. In the context of these Regulations, students may also refer to individual learners who acquire knowledge, skills and competencies, or satisfy their educational needs in intellectual, spiritual, physical and/or professional personal growth, as well as applicants;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.5.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>выпускник </i>
          </b>
          – физическое лицо, завершившее освоение образовательной программы;
        </Fragment>
      ) : (
        "Graduatesare individuals who have completed their studies in a specific HSE educational programme;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.6.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>обработка персональных данных (далее – обработка ПДн) </i>
          </b>
          – любое действие (операция) или совокупность действий (операций),
          совершаемых с использованием средств автоматизации или без
          использования таких средств с персональными данными, включая сбор,
          запись, систематизацию, накопление, хранение, уточнение (обновление,
          изменение), извлечение, использование, передачу (распространение,
          предоставление, доступ), обезличивание, блокирование, удаление,
          уничтожение персональных данных;
        </Fragment>
      ) : (
        "Personal data processing (hereafter, “PD processing”) involves any activity (operation) or a combination of activities (operations), performed manually or relying on automated means for PD processing, including collection, recording, systematization, accumulation, storage, specification (renewal, change), retrieval, use, transfer (distribution, provision, access), depersonalization, blocking, deletion, and destruction of PD;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.7.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>оператор </i>
          </b>
          – государственный или муниципальный орган, юридическое или физическое
          лицо, самостоятельно или совместно с другими лицами организующие и
          (или) осуществляющие обработку персональных данных, а также
          определяющие цели обработки персональных данных, состав персональных
          данных, подлежащих обработке, действия (операции), совершаемые с
          персональными данными. Для целей Положения оператором является НИУ
          ВШЭ;
        </Fragment>
      ) : (
        "An operator is a body of the government or municipal authorities, a legal entity or an individual, acting individually or jointly with other persons, who organize and/or engage in PD processing, as well as determine the purposes of such processing activities, the composition of PD that is subject to processing and actions (operations) performed. In the context of these Regulations, HSE is regarded as the operator;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 2.1.8.{" "}
      {isRus ? (
        <Fragment>
          <b>
            <i>законодательство о ПДн </i>
          </b>
          – Конституция Российской Федерации, Федеральный закон от 27.07.2006 №
          152-ФЗ «О персональных данных» и иные нормативные правовые акты,
          регулирующие отношения, связанные с обработкой ПДн.
        </Fragment>
      ) : (
        "Legislation on PD is specified in the Constitution of the Russian Federation and Federal Law No. 152-FZ “On Personal Data”, dated July 27, 2006, as well as other bylaws and regulations on PD processing."
      )}
      <br />
      <br />
      <h4>
        <b>
          3.{" "}
          {isRus
            ? "Условия обработки персональных данных"
            : "Terms and Conditions on PD Processing"}
        </b>
      </h4>
      <br />
      &nbsp; 3.1.{" "}
      {isRus
        ? "Получая ПДн от работников, обучающихся, иных лиц, указанных в настоящем Положении, и начиная их хранение, НИУ ВШЭ становится оператором. Обработка ПДн осуществляется НИУ ВШЭ с соблюдением принципов, условий и правил, предусмотренных законодательством о ПДн, в следующих основных случаях:"
        : "After receiving PD from staff, students and other persons specified herein, and accepting this information for storage, HSE shall thereby be deemed an operator. The University shall process PD in line with the principles, terms and conditions stipulated in legislation on PD in regards to the following cases:"}
      <br />
      <br />
      &nbsp;&nbsp; 3.1.1.{" "}
      {isRus ? (
        <Fragment>
          <b>
            обработка персональных данных осуществляется с согласия субъекта ПДн
            на обработку его ПДн.
          </b>{" "}
          При этом для обработки специальных категорий ПДн, касающихся расовой,
          национальной принадлежности, политических взглядов, религиозных или
          философских убеждений, состояния здоровья, интимной жизни,
          биометрических ПДн, если обработка таких ПДн не противоречит локальным
          нормативным актам НИУ ВШЭ, равно как и для включения любых ПДн в
          общедоступные источники ПДн и/или передачи ПДн работников третьим
          лицам необходимо получение указанного согласия в письменной форме либо
          в форме электронного документа, подписанного усиленной
          квалифицированной электронной подписью.
        </Fragment>
      ) : (
        "PD processing shall be performed upon the consent of a given PD Subject. The processing of special categories of PD with respect to one’s race or nationality, political views, religious or philosophical convictions, health, sexual relations, and biometric PD, if the processing of such PD does not come into contradiction with HSE’s bylaws, as well as making any PD available to public and/or disclosing staff-related PD to any third parties, shall be implemented on the basis of the PD Subject’s consent, provided either in writing, by an e-mail certified with a valid electronic signature."
      )}
      &nbsp;&nbsp;
      {isRus
        ? "К указанному случаю относится, в частности, обработка ПДн:"
        : "Such cases include, in particular, the processing of PD relating to:"}
      <br />
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "соискателей на замещение вакантных должностей для целей, обусловленных принятием решения в отношении их кандидатур, в том числе получения информации у предшествующих работодателей, обеспечения должного уровня безопасности при их посещении территорий и помещений, на/в которых расположен НИУ ВШЭ; формирования и использования банка данных перспективных соискателей;"
          : "candidates to open vacancies, as required for reaching final decisions on their candidacies, including references from previous employers, ensuring the due level of security on HSE premises; accumulating and using databases with information on applicants;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "работников НИУ ВШЭ в целях информационного обеспечения деятельности НИУ ВШЭ, в том числе посредством ведения онлайн справочников, адресных книг, включая страницу «Преподаватели и сотрудники» корпоративного сайта (портала) НИУ ВШЭ, корпоративную информационную систему «Телефонный справочник» и иные общедоступные источники ПДн; печати и размещения информационных табличек; печати и предоставления визитных карточек; приема, фиксации и исполнения заявок, заявлений, запросов и иных видов обращений субъектов ПДн; оформления полисов обязательного медицинского страхования, добровольного медицинского страхования; обеспечения действующего в НИУ ВШЭ уровня безопасности, в том числе действующего пропускного режима и контроля его соблюдения, видеонаблюдения и видеозаписи на территории и в помещениях, на/в которых расположен НИУ ВШЭ; идентификации личности работника НИУ ВШЭ; проведения в НИУ ВШЭ мероприятий и освещения информации о них, в том числе при проведении видеозаписи проводимых мероприятий; обеспечения возможности НИУ ВШЭ для оформления отношений с кредитными организациями, открывающими и обслуживающими платежные карты для начисления и перечисления заработной платы; обеспечения возможности НИУ ВШЭ привлечения третьих лиц для ведения кадрового, бухгалтерского и налогового учета; обеспечения информирования о проводимых НИУ ВШЭ мероприятиях, выполняемых исследованиях, реализуемых проектах и их результатах; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том числе путем осуществления прямых контактов с субъектами ПДн с помощью средств связи; обеспечения правовой охраны интеллектуальной собственности; выполнения работ, в том числе научно-исследовательских, опытно-конструкторских и технологических, и оказания услуг по заказам третьих лиц и в рамках исполнения государственного задания, осуществления экспертно-аналитической деятельности; статистических и иных исследовательских целях, научной и иной творческой деятельности, осуществляемой в НИУ ВШЭ;"
          : "HSE staff, in order to ensure information support for the University’s operations: including the maintenance of online reference books and address books, including the “Information for Faculty and Staff” page («Преподаватели и сотрудники») on HSE’s corporate website (portal), the “Telephone Directory” («Телефонный справочник») corporate information system, as well as other open PD sources; producing and placing information plates; printing and distributing business cards; acceptance, registration and execution of applications and inquiries, as well as other kinds of applications submitted by PD Subjects; issuing mandatory and private health insurance policies; ensuring necessary security at HSE, including applicable access control, video monitoring and recording on the University’s premises; personal identification of HSE staff; holding events at the University and providing relevant information, including video recordings of events; enabling HSE to enter into agreements with issuers of bank cards used for salary payments; enabling HSE to engage third party service providers for the maintenance of staff-related, accounting and tax records; providing information on events at the University, research projects, and related deliverables; promotion of HSE’s products, works and services, (e.g., through directly contacting PD Subjects); ensuring legal protection of intellectual property; completing R&D assignments and rendering services by order of third parties and in the framework of state assignments; engaging in expert and analytical activities; for statistical and other research purposes, as well as HSE’s research and creative activities;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "бывших работников НИУ ВШЭ в целях обеспечения ретроспективы кадрового учета; обеспечения информирования о проводимых НИУ ВШЭ мероприятиях, выполняемых исследованиях, реализуемых проектах и их результатах; предоставления таким работникам справок, в том числе для подтверждения стажа и размеров заработной платы; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том числе путем осуществления прямых контактов с субъектами ПДн с помощью средств связи;"
          : "former HSE staff, in order to maintain consistent staff records: providing information on HSE events, research projects and respective deliverables; issuing certificates to staff, including confirmations of their terms of service and salaries; marketing promotion of HSE’s products, works and services (e.g., through directly contacting PD Subjects);"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "участников проводимых НИУ ВШЭ или с его непосредственным участием познавательных, образовательных и научных мероприятий с целью учета количества участников, анализа их профессиональных интересов, обеспечения действующего в НИУ ВШЭ уровня безопасности, в том числе действующего пропускного режима и контроля его соблюдения, видеонаблюдения и видеозаписи на территории и в помещениях, на/в которых расположен НИУ ВШЭ; обеспечения информирования о проводимых НИУ ВШЭ мероприятиях, выполняемых исследованиях, реализуемых проектах и их результатах; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том числе путем осуществления прямых контактов с субъектами ПДн с помощью средств связи;"
          : "participants in academic, educational or research events hosted by and/or involving HSE, in order to register the total number of participants and analyze their professional interests: ensuring necessary security at HSE, including applicable access control, video monitoring and recording on the University’s premises; providing information on events at HSE, research projects and related deliverables; marketing promotion of HSE’s products, works and services, (e.g., through directly contacting PD Subjects);"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "обучающихся НИУ ВШЭ в целях раскрытия и развития их талантов и способностей; эффективного формирования образовательных траекторий и внедрения в образовательные процессы практико-ориентированных компонентов, повышающих качество подготовки и востребованность успешных обучающихся на рынках труда; формирования возможностей онлайн образования, в частности, посредством единой информационной образовательной среды (LMS - Learning Management System) и иных платформ НИУ ВШЭ, в том числе с передачей их ПДн третьим лицам; учета посещаемости и успеваемости, а также определения причин, оказывающих негативное влияние на таковые; размещения на корпоративном портале (сайте) НИУ ВШЭ сведений о прохождении ими практик, подготовленных промежуточных (курсовых) и итоговых контрольных (выпускных квалификационных) работ, самих таких работ, результатов текущего контроля успеваемости, промежуточной, итоговой и государственной итоговой аттестации, для обеспечения открытости и прозрачности процесса их оценивания; обеспечения их участия в выполнении работ, в том числе научно-исследовательских, опытно-конструкторских и технологических работ, и оказании услуг по заказам третьих лиц и в рамках исполнения государственного задания; содействия в трудоустройстве, в том числе с передачей их ПДн третьим лицам; формирования единого сообщества обучающихся для повышения интереса и междисциплинарной интеграции; обеспечения информирования о проводимых НИУ ВШЭ мероприятиях, выполняемых исследованиях, реализуемых проектах и их результатах; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том числе путем осуществления прямых контактов с субъектами ПДн с помощью средств связи;"
          : "HSE students, in order to identify and enhance their talents and abilities: shape effective educational trajectories and introduce practice-oriented components into educational processes, in order to boost the quality of education and facilitate the successful employment of students upon their graduation; making online education opportunities available, in particular, on the basis of the Learning Management System (LMS) and other HSE platforms, including transfer of relevant PD to third parties; taking attendance and academic performance records, as well as establishing the reasons for any negative effect thereon; publishing information on student internships, interim (term) and final examination papers (theses), as well as the texts of such papers, the results of ongoing assessments, interim and final certification on HSE’s corporate website (portal), in order to ensure the transparency of the assessment process; ensuring student involvement in the preparation of papers, including R&D papers, as well as the provision of services on the part of third parties and in the framework of fulfilling government assignments; facilitating student employment upon graduation, including the transfer of related PD to third parties; cultivating a student community with the aim of boosting interest in cross-disciplinary integration; providing information on events at the University, research projects and related deliverables; marketing promotion of HSE’s products, works and services (e.g., through directly contacting PD Subjects);"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "выпускников НИУ ВШЭ в целях содействия в трудоустройстве, в том числе с передачей их ПДн третьим лицам; формирования единого сообщества выпускников, в том числе для обеспечения возможности их взаимодействия с обучающимся (наставничества) и мотивации обучающихся; обеспечения информирования о проводимых НИУ ВШЭ мероприятиях, выполняемых исследованиях, реализуемых проектах и их результатах; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том числе путем осуществления прямых контактов с субъектами ПДн с помощью средств связи;"
          : "HSE graduates, with the aim of facilitating their employment, including transfer of relevant PD to third parties; establishing a student community, including the aim of organizing cooperation with students (coaching) and motivating students; providing information on events at HSE, research projects and related deliverables; marketing promotion of the University’s products, works and services (e.g., through directly contacting PD Subjects);"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "руководителей и иных представителей юридических лиц – контрагентов или потенциальных контрагентов по договорам, соглашениям и контрактам (далее в совокупности – договоры) в целях подготовки к заключению договоров и исполнения таких договоров, ведения учета заключенных договоров."
          : "managers and other authorized representatives of legal entities, including (potential) counterparties under contracts and agreements (hereafter, jointly referred to as “agreements”), with the aim of making preparations for the conclusion and execution of such agreements and maintenance of related records."}
      </li>
      <br />
      <br />
      &nbsp;&nbsp; 3.1.2.{" "}
      {isRus ? (
        <b>
          обработка ПДн необходима для осуществления и выполнения возложенных
          законодательством Российской Федерации на НИУ ВШЭ как оператора
          функций, полномочий и обязанностей, в том числе:
        </b>
      ) : (
        "HSE shall perform PD processing acting as an operator, pursuant to Russian legislation, with respect to the requirements of the following respective regulations, including:"
      )}
      <br />
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "трудовым законодательством (включая законодательство об охране труда), состоящим из Трудового кодекса Российской Федерации, иных федеральных законов и законов субъектов Российской Федерации, содержащих нормы трудового права;"
          : "labour legislation (including labour safety laws), including the Russian Labour Code, other federal laws and respective legislation of the constituent bodies of the Russian Federation, relating to labour regulations;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "Правилами ведения реестра договоров, заключенных заказчиками по результатам закупки, утвержденными постановлением Правительства Российской Федерации от 31.10.2014 № 1132;"
          : "rules for maintaining a register of concluded procurement agreements, pursuant to Directive of the Russian Government No. 1132, dated October 31, 2014;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "Порядком проведения олимпиад школьников, утвержденным приказом Министерства образования и науки Российской Федерации от 04.04.2014 № 267;"
          : "the Procedure for Student Competitions, as approved by Directive of the Ministry of Education and Science of the Russian Federation No. 267, dated April 04, 2014;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "Порядком приема на обучение по образовательным программам высшего образования - программам бакалавриата, программам специалитета, программам магистратуры, утвержденным приказом Министерства образования и науки Российской Федерации от 14.10.2015 № 1147;"
          : "admission procedures for enrolment to degree programmes at the Bachelor’s, Specialist, and Master’s level, as approved by Directive of the Ministry of Education and Science of the Russian Federation No. 1147, dated October 14, 2015;"}
      </li>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <li>
        {isRus
          ? "иными нормативными правовыми актами Российской Федерации."
          : "other bylaws of the Russian Federation."}
      </li>
      &nbsp;&nbsp;{" "}
      {isRus
        ? "К указанному случаю относится, в частности, обработка ПДн работников, обучающихся, абитуриентов, участников олимпиад и конкурсов, а также физических лиц – контрагентов НИУ ВШЭ."
        : "Such cases can also include processing PD provided by HSE staff, students, applicants and participants of academic competitions, as well as individuals considered as HSE counterparties."}
      <br />
      <br />
      &nbsp;&nbsp; 3.1.3.{" "}
      {isRus ? (
        <b>
          обработка ПДн необходима для исполнения договора, стороной которого
          либо выгодоприобретателем или поручителем по которому является субъект
          ПДн, в том числе в случае реализации оператором своего права на
          уступку прав (требований) по такому договору, а также для заключения
          договора по инициативе субъекта ПДн или договора, по которому субъект
          ПДн будет являться выгодоприобретателем или поручителем.
        </b>
      ) : (
        "PD processing shall be required for executing agreements to which a PD Subject is a party, or a beneficiary, or a guarantor, including in cases whereby the operator exercises its right to assign rights (claims) under an agreement, as well as for concluding agreements upon the PD Subject’s initiative, and/or agreements to which the PD Subject is a party, or a beneficiary, or a guarantor."
      )}
      <br />
      &nbsp;&nbsp;
      {isRus
        ? "К указанному случаю относится, в частности, обработка ПДн обучающихся на местах по договорам об оказании платных образовательных услуг, в том числе обучающихся по дополнительным профессиональным программам, прочих получателей услуг и работ НИУ ВШЭ, а также физических лиц – контрагентов НИУ ВШЭ. К указанному случаю обработки ПДн может также относиться обработка, осуществляемая НИУ ВШЭ на основании предоставляемых в связи с заключением указанных договоров согласий на обработку ПДн."
        : "Such cases include the processing of the PD of students studying on fee-paying places under paid educational services agreements, including students taking part continuing professional development programmes and other HSE clients, as well as individuals acting as counterparties of HSE. Such cases may also include processing performed by HSE on the basis of consent for processing PD provided in regards to the conclusion of such agreements."}
      <br />
      <br />
      &nbsp;&nbsp; 3.1.4.{" "}
      {isRus ? (
        <b>
          обработка ПДн необходима для научной, литературной или иной творческой
          деятельности при условии, что при этом не нарушаются права и законные
          интересы субъекта персональных данных;
        </b>
      ) : (
        "PD processing is required in the context of research, literary and any other creative activities, provided that the rights and legal interests of the PD Subject are properly observed;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 3.1.5.{" "}
      {isRus ? (
        <b>
          обработка ПДн осуществляется в статистических или иных
          исследовательских целях, при условии обязательного обезличивания ПДн;
        </b>
      ) : (
        "PD processing is performed for statistical and other research-related purposes, provided that this information must be subject to depersonalization;"
      )}
      <br />
      <br />
      &nbsp;&nbsp; 3.1.6.{" "}
      {isRus ? (
        <b>
          осуществляется обработка ПДн, доступ неограниченного круга лиц к
          которым предоставлен субъектом ПДн либо по его просьбе (ПДн, сделанные
          общедоступными субъектом ПДн).
        </b>
      ) : (
        "PD processing is performed with respect to information, which is publicly available upon consent and/or as per the request of the PD Subject (including PD made publicly available in general)."
      )}
      <br />
      <br />
      &nbsp; 3.2.{" "}
      {isRus
        ? "Все вышеуказанные ПДн субъектов, групп субъектов ПДн и иные ПДн обрабатываются в объеме и в сроки, предусмотренные соответствующими согласиями на обработку ПДн, в том числе выраженными в тексте трудовых и гражданско-правовых договоров, и/или в нормативных правовых актах, и/или локальных нормативных актах НИУ ВШЭ, и/или вытекающими из таких нормативных правовых актов и локальных нормативных актов НИУ ВШЭ, либо в сроки, необходимые для достижения указанных целей. Вышеперечисленные условия обработки ПДн не являются исчерпывающими. Предоставляемые согласия на обработку ПДн могут дополнять или изменять иным образом цели, объем, способы и сроки обработки ПДн."
        : "The aforementioned data of PD Subjects, groups of PD Subjects and other PD shall be processed as per the requirements for relevant consent for PD processing, including consent provided through employment and independent contractor agreements, and/or official regulations, and/or HSE’s respective bylaws, as well as related regulations and bylaws, or within a given established timeframe. These include, but are not limited to, general terms and conditions for PD processing. Consent for PD processing provided by PD Subjects may be amended with respect to the given purpose, size, methods and deadlines of PD processing."}
      <br />
      <br />
      &nbsp; 3.3.{" "}
      {isRus
        ? "Обработка ПДн иных лиц осуществляется при наличии их согласий, если они фактически взаимодействуют с НИУ ВШЭ, в том числе в форме возникающих или существующих правоотношений. Если иное не указано в Положении, заключаемых договорах или предоставляемых субъектами ПДн согласиях на обработку ПДн, НИУ ВШЭ использует такие ПДн исключительно для целей, для которых они были предоставлены университету, в частности, в целях предоставления ответов на вопросы, предоставления доступа к определенной информации и знаниям."
        : "PD of other persons shall be processed upon their consent provided in the course of their cooperation/legal relations with HSE. Unless otherwise specified within these Regulations, relevant agreements and/or consent for PD processing provided by PD Subjects, HSE shall exclusively use such information for intended purposes, including answering questions, as well as making certain information and knowledge available."}
      <br />
      <br />
      &nbsp; 3.4.{" "}
      {isRus
        ? "Работники НИУ ВШЭ, которые обрабатывают ПДн в университете, заблаговременно, до начала обработки ПДн, должны убедиться в ее допустимости и законности, удостовериться относительно обладания университетом соответствующими полномочиями и/или согласиями субъектов ПДн. При отсутствии таких полномочий и/или согласий указанный работник НИУ ВШЭ должен обеспечить получение согласия от субъекта, обработка ПДн которого планируется. В этой связи он может:"
        : "Prior to processing PD, relevant HSE staff must make sure that such PD processing is lawful, that the University has respective authorities, and/or related consents have been provided by PD subjects. In case these authorities and/or consent are not available, HSE staff must obtain the PD Subject’s consent for PD processing. The following steps can be undertaken for these purposes:"}
      <br />
      <br />
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "предусматривать в различных электронных регистрационных формах, переписке по электронной почте и телефонных переговорах получение согласий на обработку ПДн от соответствующих субъектов ПДн с обязательной фиксацией такого согласия в любой позволяющей подтвердить факт его получения форме, в том числе с последующим личным подтверждением предоставления согласий такими субъектами;"
          : "requests for a PD Subject’s consent for PD processing may be presented in different online registration forms, messages sent via e-mail and through phone calls, with confirmation provided by the PD Subject in any form, including his/her subsequent personal confirmation;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "применять рекомендуемую форму письменного согласия, размещенную на странице корпоративного сайта (портала) НИУ ВШЭ по адресу: "
          : "a recommended format for written consent is available on HSE’s corporate website (portal) at"}
        <a href="https://legal.hse.ru/rndip/information_sharing">
          https://legal.hse.ru/rndip/information_sharing.
        </a>
      </li>
      <br />
      <br />
      &nbsp; 3.5.{" "}
      {isRus
        ? "К работникам НИУ ВШЭ, которые обрабатывают ПДн в университете, по должности относятся:"
        : "The list of HSE staff involved in PD processing includes:"}
      <br />
      <br />
      &nbsp;&nbsp;<li>{isRus ? "ректор;" : "Rector;"}</li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "президент, вице-президент, научный руководитель;"
          : "President, Vice President, Academic Supervisor;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "первые проректоры, проректоры, находящиеся в непосредственном подчинении ректору;"
          : "First Vice Rectors and Vice Rectors directly reporting to the Rector;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "проректоры, находящиеся в непосредственном подчинении первым проректорам, старшие директора и директора по направлениям деятельности;"
          : "Vice Rectors directly reporting to First Vice Rectors, senior directors and directors for specific directions;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Секретариата университета;"
          : "HSE Rector’s Office staff;"}
      </li>
      &nbsp;&nbsp;<li>{isRus ? "главный бухгалтер;" : "Chief Accountant;"}</li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления персонала;"
          : "Human Resources Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления бухгалтерского учета;"
          : "Accounting Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Планово-финансового управления;"
          : "Planning and Finance Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Дирекции по правовым вопросам;"
          : "Legal Support Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления виз и регистраций Дирекции по интернационализации;"
          : "Visa and Registration Unit staff within the Office of Internationalization;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления делами;"
          : "Administration and General Services Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления по информационным ресурсам и управления разработки и поддержки информационных систем портала Дирекции по связям с общественностью и информационным ресурсам;"
          : "staff of the Online Media Unit and the Office for Development and Support of HSE Website (portal) Information Systems within the Office of Public Relations and Online Media;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Управления по работе с абитуриентами и Управления дополнительного образования – в отношении ПДн абитуриентов;"
          : "Admissions Office staff and staff of the Office for Continuing Education - with respect to PD provided by applicants;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Дирекции основных образовательных программ, Дирекции по профессиональной ориентации и работе с одаренными учащимися, Управления дополнительного образования, факультетов – в отношении ПДн обучающихся;"
          : "respective staff of the HSE Office of Degree Programmes, Office for Occupational and Gifted Student Guidance, Office for Continuing Education - with respect to PD submitted by students;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Дирекции по безопасности;"
          : "Security Office staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работники Дирекции информационных технологий и Управления развития информационных технологий."
          : "staff of the IT Office and Office for Information Technologies Development."}
      </li>
      <br />
      <br />
      &nbsp;
      {isRus
        ? "Ректор, первые проректоры, проректоры, директора и старшие директора могут делегировать часть своих полномочий иным работникам НИУ ВШЭ в порядке, предусмотренном локальными нормативными актами НИУ ВШЭ, а также определять иных лиц, которые в соответствии со своей трудовой функцией имеют непосредственное отношение к обработке ПДн."
        : "HSE’s Rector, First Vice Rectors, Vice Rectors, directors and senior directors can delegate part of their authorities to HSE staff, as per the University’s bylaws, and appoint other persons who are directly involved in PD processing in the framework of their employment role."}
      <br />
      <br />
      &nbsp; 3.6.{" "}
      {isRus ? (
        <Fragment>
          Всякий раз, когда получение необходимого согласия на обработку ПДн
          невозможно и имеются достаточные основания полагать, что обработка ПДн
          может нарушить права субъекта(-ов) ПДн, соответствующий работник НИУ
          ВШЭ уведомляет любым фиксированным способом (на бумажном носителе, по
          корпоративной электронной почте, факсимильной связью) об этом
          Управление персонала НИУ ВШЭ (в отношении ПДн работников),
          руководителей структурных подразделений, реализующих образовательные
          программы (в отношении ПДн обучающихся), и/или Дирекция по правовым
          вопросам (в отношении ПДн остальных субъектов) для выработки
          обоснованного подхода к обработке ПДн или установления невозможности
          их обработки.
          <br />
          <br />
          Руководители структурных подразделений НИУ ВШЭ, в непосредственной
          деятельности которых происходит обработка ПДн граждан, обеспечивают
          принятие всех необходимых мер по соблюдению законности обработки ПДн,
          в том числе получение согласий на обработку и, при необходимости,
          разработку локальных нормативных актов, определяющих условия обработки
          ПДн соответствующих групп субъектов.
        </Fragment>
      ) : (
        <Fragment>
          If necessary consent for PD processing is unavailable, or there are
          sufficient grounds to believe that PD processing may result in the
          violation of the rights of the PD Subject(s), HSE staff shall inform
          the HSE Office of Human Resources (by sending a letter in hard copy,
          or by corporate email, or by fax) (in regards to the PD of HSE staff),
          heads of respective subdivisions implementing degree programmes (in
          regards to PD of students), and/or the Legal Support Office (in
          regards to PD of other PD Subjects), in order to select an approach to
          PD processing, or thereby decide that such PD is not subject to
          processing.
          <br />
          <br />
          Heads of HSE subdivisions engaged in PD processing shall take all
          necessary measures in order to make sure that PD processing is
          organized in compliance with legislation, including obtaining relevant
          consent for PD processing, and, if necessary, develop bylaws to
          regulate terms and conditions of PD processing, with respect to
          relevant PD Subjects.
        </Fragment>
      )}
      <br />
      <br />
      &nbsp; 3.7.{" "}
      {isRus ? (
        <Fragment>
          В отсутствие указания на иное, предоставляя свои ПДн университету,
          субъект ПДн принимает условия Положения и тем самым свободно, своей
          волей и в своем интересе распоряжается ими, осознает последствия их
          предоставления и выражает свое согласие на их обработку в целях, для
          достижения которых они предоставляются, а также в целях соблюдения НИУ
          ВШЭ нормативных и ненормативных правовых актов, принимаемых в
          Российской Федерации; исполнения решений, поручений и запросов органов
          государственной власти, осуществляющих отдельные функции и полномочия
          учредителя НИУ ВШЭ, а также иных органов государственной власти и их
          должностных лиц; обеспечения информирования о проводимых НИУ ВШЭ
          мероприятиях, выполняемых исследованиях, реализуемых проектах и их
          результатах; продвижения товаров, работ, услуг НИУ ВШЭ на рынке, в том
          числе путем осуществления прямых контактов с субъектами ПДн с помощью
          средств связи; осуществления НИУ ВШЭ уставной деятельности; а также
          аккумуляции сведений о лицах, взаимодействующих с НИУ ВШЭ, путем
          сбора, записи, систематизации, накопления, хранения, уточнения
          (обновление, изменение), извлечения, использования, передачи
          (распространения, предоставления, доступа), обезличивания,
          блокирования, удаления, уничтожения, совершаемых, в том числе с
          использованием средств автоматизации. Объем обрабатываемых ПДн в
          указанном случае ограничивается теми данными, которые предоставлены
          субъектами ПДн самостоятельно, а срок обработки ПДн составляет 5
          (пять) лет с момента их предоставления.
          <br />
          <br />
          Несмотря на широкий перечень действий, допустимых с ПДн, на совершение
          которых дается такое согласие, при обработке ПДн НИУ ВШЭ
          ограничивается достижением конкретных, заранее определенных, законных
          целей и не допускает избыточности их обработки.
          <br />
          <br />
          НИУ ВШЭ воздерживается от продажи или предоставления в пользование ПДн
          в какой-либо объективной форме. Обработка ПДн в НИУ ВШЭ за пределами
          вышеуказанных случаев, в отсутствие согласий субъектов ПДн на их
          обработку, запрещена.
        </Fragment>
      ) : (
        <Fragment>
          Unless otherwise provided, as per submission of their PD to the
          University, the PD Subject thereby shall agree to the terms and
          conditions of these Regulations, and, in their free will and interest,
          shall control their PD, understand consequences of their PD disclosure
          and provide their consent to related PD processing for relevant
          purposes, as well for the purposes of HSE compliance with official
          regulations and bylaws of the Russian Federation; execution of
          decisions, orders and inquiries of government authorities, which are
          deemed as HSE’s founders, as well as other state authorities and
          related officials; providing information on events organized by HSE,
          research projects, and related deliverables; marketing promotion of
          HSE products, works and services, including through directly
          contacting PD Subjects; implementing HSE activities as per the
          University’s Charter; as well as accumulating information on persons
          and entities acting as HSE counterparties, through such activities as
          gathering, recording, systematization, accumulation, storage,
          clarification (renewal, change), retrieval, use, transfer
          (distribution, provision, access), depersonalization, blocking,
          deletion and destruction, performed both manually and via automated
          means. The overall volume of PD processed in such situations shall be
          limited to data provided by PD Subjects. Also, the period for PD
          processing shall come to 5 (five) years after submission.
          <br />
          <br />
          Despite a wide range of operations that may be performed with PD upon
          consent, HSE shall only carry out PD processing for pre-determined
          legal purposes.
          <br />
          <br />
          HSE must refrain from selling or making PD available in any form. In
          turn, PD shall be processed at the University only for the
          aforementioned purposes upon consent provided by PD Subjects. In any
          other cases, the use of PD is prohibited.
        </Fragment>
      )}
      <br />
      <br />
      <h4>
        <b>4. {isRus ? "Доступ к персональным данным" : "Access to PD"}</b>
      </h4>
      <br />
      &nbsp; 4.1.{" "}
      {isRus
        ? "К обработке ПДн в НИУ ВШЭ допускаются только те лица, которые указаны или определены в Положении, лица, которым в установленном настоящим Положением порядке делегированы соответствующие полномочия, а также лица, чьи ПДн подлежат обработке."
        : "Access to processed PD at HSE shall only be granted to persons designated and/or specified in these Regulations, as well as persons who are duly authorized by these Regulations and PD Subjects themselves."}
      <br />
      <br />
      &nbsp; 4.2.{" "}
      {isRus
        ? "Иные работники НИУ ВШЭ могут получать доступ к ПДн в целях чтения и подготовки методических, аналитических, сводных и иных материалов в части вопросов, относимых к деятельности таких лиц или структурных подразделений НИУ ВШЭ, к которым они относятся. Доступ иных работников НИУ ВШЭ к ПДн может быть осуществлен исключительно при условии предоставления университету обязательств таких лиц по сохранению соответствующих ПДн в тайне."
        : "Other HSE staff may acquire PD access in order to read and prepare methodological, analytical, consolidated reports and other materials on any matters relating to the competence of such persons and HSE’s relevant subdivisions. Other staff of the University may be granted PD access only on the condition that such persons undertake to observe effective confidentiality with respect to such information."}
      <br />
      <br />
      &nbsp; 4.3.{" "}
      {isRus
        ? "Доступ к ПДн, содержащимся в каких-либо электронных базах данных и в информационных системах университета, осуществляется на основании решения Старшего директора по информационным технологиям или лица, его замещающего. В основе такого решения лежит совокупность различных факторов, влияющих на возможность нарушения законодательства о ПДн, в частности, возможность неправомерного доступа и распространения ПДн."
        : "Access to PD maintained in HSE’s electronic databases and information systems shall be granted following a decision of the Senior IT Director or an official authorized to act on behalf of the Senior IT Director. Such decisions shall be made, giving due consideration to a whole range of factors, in order to avert any violation of legislation on PD processing (e.g., unauthorized access to PD and distribution of such information, etc.)."}
      <br />
      <br />
      &nbsp; 4.4.{" "}
      {isRus
        ? "Лица, виновные в нарушении порядка обработки ПДн, несут предусмотренную законодательством Российской Федерации ответственность. В отношении работников НИУ ВШЭ, нарушивших порядок обработки ПДн, могут быть применены дисциплинарные взыскания."
        : "Persons liable for violations of PD processing rules shall bear responsibility as per Russian legislation. Disciplinary measures may be applied to HSE staff who are liable for violations of PD processing rules."}
      <br />
      <br />
      <h4>
        <b>
          5.{" "}
          {isRus
            ? "Особенности защиты персональных данных работников"
            : "Special Aspects of Staff PD Protection"}
        </b>
      </h4>
      <br />
      &nbsp; 5.1.{" "}
      {isRus
        ? "Получая ПДн от работников, обучающихся, иных лиц, указанных в настоящем Положении, и начиная их хранение, НИУ ВШЭ становится оператором. Обработка ПДн осуществляется НИУ ВШЭ с соблюдением принципов, условий и правил, предусмотренных законодательством о ПДн, в следующих основных случаях:"
        : "PD protection refers to the implementation of legal, organizational and technical measures focused on:"}
      <br />
      <br />
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "обеспечение защиты ПДн от неправомерного доступа, уничтожения, модифицирования, блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий в отношении ПДн;"
          : "ensuring PD protection from unauthorized access, destruction, modification, blocking, copying, provision and distribution, as well as other illegal operations with PD;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus ? "соблюдение конфиденциальности ПДн;" : "PD confidentiality;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "реализацию права на доступ к ПДн."
          : "providing rights for access to PD."}
      </li>
      <br />
      <br />
      &nbsp; 5.2.{" "}
      {isRus
        ? "Университет обеспечивает эффективную работу системы защиты ПДн, которая включает в себя организационные и (или) технические меры, определенные с учетом актуальных угроз безопасности ПДн и информационных технологий, используемых в информационных системах. Обеспечение защиты ПДн в университете осуществляется Дирекцией информационных технологий Национального исследовательского университета «Высшая школа экономики»."
        : "HSE shall ensure the efficiency of its PD security system, including such activities as organizational and/or technical measures, determined with due consideration of actual security risks to PD and the information technologies used in information systems. The HSE Office of Information Technology is responsible for PD protection at the University."}
      <br />
      <br />
      &nbsp; 5.3.{" "}
      {isRus
        ? "Защита ПДн работников НИУ ВШЭ от неправомерного их использования или утраты обеспечивается за счет средств университета в порядке, установленном федеральным законом."
        : "Protection of HSE staff’s PD from unauthorized access and/or loss shall be ensured at the University’s expense, as per the procedure established by federal legislation."}
      <br />
      <br />
      &nbsp; 5.4.{" "}
      {isRus
        ? "Защита ПДн, хранящихся в электронных базах данных и в информационных системах университета, от несанкционированного доступа, искажения и уничтожения информации, а также от иных неправомерных действий, обеспечивается разграничением прав доступа с использованием учетной записи и системы паролей."
        : "PD stored within HSE’s electronic databases and information systems shall be protected from unauthorized access, distortion and destruction, as well as any other illegal operations, through diversification of rights of access, relying on a system of logins and passwords."}
      <br />
      <br />
      &nbsp; 5.5.{" "}
      {isRus
        ? "Организация хранения ПДн в университете осуществляется в порядке, исключающем их утрату или их неправомерное использование."
        : "PD storage at HSE shall be organized so as to avert their loss or unauthorized use."}
      <br />
      <br />
      &nbsp; 5.6.{" "}
      {isRus
        ? "Организацию и контроль за защитой ПДн работников университета, осуществляют работники НИУ ВШЭ, которые обрабатывают ПДн в университете по должности, а также руководители соответствующих структурных подразделений, работники которых обрабатывают ПДн в университете по должности."
        : "HSE staff responsible for PD processing, as well as heads of relevant subdivisions, shall organize and monitor the protection of HSE staff’s PD."}
      <br />
      <br />
      &nbsp; 5.7.{" "}
      {isRus
        ? "Для регламентации доступа работников НИУ ВШЭ к ПДн, документам, в том числе электронным, иным материальным носителям, базам данных и информационным системам, содержащим ПДн, в целях исключения несанкционированного доступа третьих лиц и защиты ПДн работников первые проректоры, проректоры, директора и старшие директора, а также руководители соответствующих структурных подразделений, работники которых обрабатывают ПДн в университете по должности, обязаны соблюдать и обеспечивать:"
        : "HSE’s First Vice Rectors, Vice Rectors, directors  and senior directors, as well as the heads of relevant subdivisions and departments responsible for PD processing at the University, shall observe and implement the following procedures, in order to regulate the access of HSE staff to PD, documents (including e-documents), other material data storage devices, databases and information systems containing PD, in order to prevent unauthorized access of any third parties and protection of the PD of HSE’s staff:"}
      <br />
      <br />
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "ограничение и регламентацию состава работников, трудовые обязанности которых требуют доступа к ПДн;"
          : "limiting and setting rules for employees whose job responsibilities require access to PD;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "строгое избирательное и обоснованное распределение документов, иных материальных носителей, содержащих ПДн, между работниками;"
          : "ensuring strictly selective and rational distribution of documents and other data storage devices containing PD among HSE’s staff;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "рациональное размещение рабочих мест работников, при котором исключается бесконтрольное использование ПДн;"
          : "ensuring rational distribution of employees’ workplaces in order to properly monitor PD usage and access;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "знание соответствующими работниками требований нормативных правовых и локальных нормативных актов по защите информации и сохранении конфиденциальности такой информации;"
          : "making employees aware of requirements of applicable laws and bylaws concerning PD protection and confidentiality;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "наличие необходимых условий в помещении для работы с документами, иными материальными носителями, базами данных и информационными системами, содержащими ПДн;"
          : "ensuring adequate conditions on premises for operations with documents and other data storage devices, databases and information systems containing PD;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "определение и регламентацию состава работников, имеющих право доступа к базам данных и информационным системам, содержащим ПДн;"
          : "determining and regulating the number of employees with the right to access databases and information systems containing PD;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "организацию порядка уничтожения материальных носителей, содержащих ПДн, и его соблюдение;"
          : "spelling out procedures for the destruction of PD storage devices, as well as ensuring that this system is properly observed;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "своевременное выявление нарушения требований разрешительной системы доступа к ПДн;"
          : "ensuring timely detection of cases of unauthorized access to PD;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "работу в структурном подразделении по предупреждению утраты и разглашению ПДн при работе с ними;"
          : "organizing work in respective HSE subdivisions in order to avert and prevent PD loss or disclosure;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "сограничение доступа к документам, иным материальным носителям, базам данных и информационным системам, содержащим ПДн."
          : "limiting access to documents and other data storage devices, databases and information systems, which contain PD."}
      </li>
      <br />
      <br />
      &nbsp; 5.8.{" "}
      {isRus
        ? "Для защиты ПДн работников в НИУ ВШЭ обеспечивается соблюдение, в частности:"
        : "Protection of HSE staff’s PD shall be guaranteed by the following rules and procedures for:"}
      <br />
      <br />
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "порядка приема, учета и контроля деятельности посетителей;"
          : "reception, control and registration of visitors;"}
      </li>
      &nbsp;&nbsp;<li>{isRus ? "пропускного режима;" : "access control;"}</li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "учета и порядка выдачи пропусков;"
          : "registration and issue of passes;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "технических средств охраны, сигнализации;"
          : "technical security and signalization system;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "порядка охраны территории, зданий, помещений, транспортных средств;"
          : "procedures for security on premises, at buildings and means of transportation;"}
      </li>
      &nbsp;&nbsp;
      <li>
        {isRus
          ? "требований к защите информации при интервьюировании и собеседованиях."
          : "requirements for PD protection during interviews."}
      </li>
      <br />
      <br />
      &nbsp; 5.9.{" "}
      {isRus
        ? "Все меры по обеспечению конфиденциальности ПДн при их обработке распространяются как на материальные носители, так ПДн, представленные в электронном формате."
        : "All measures relating to PD confidentiality that are applicable during PD processing must cover both material data storage devices and any PD that is submitted electronically."}
      <br />
      <br />
      <h4>
        <b>
          6.{" "}
          {isRus
            ? "Права субъекта персональных данных"
            : "Rights of PD Subjects"}
        </b>
      </h4>
      <br />
      &nbsp; 6.1.{" "}
      {isRus
        ? "Университет не осуществляет обработку ПДн в отсутствие согласий субъектов ПДн и/или за пределами условий обработки ПДн, указанных в законодательстве о ПДн, если иное не установлено законодательством Российской Федерации."
        : "PD processing shall be performed by HSE only upon consent of PD Subjects and/or pursuant to terms and conditions of Russian legislation on PD processing unless otherwise stipulated in Russian law."}
      <br />
      <br />
      &nbsp; 6.2.{" "}
      {isRus
        ? "Субъект ПДн имеет право ознакомиться с объемом предоставленного им НИУ ВШЭ согласия и, при необходимости, обратиться в указанные в Положении структурные подразделения НИУ ВШЭ с целью совершения иных действий, предусмотренных законодательством о ПДн."
        : "PD Subjects shall be acquainted with the text of his/her consent, which is subsequently submitted to HSE and, if necessary, they may refer to the University’s subdivisions specified in the Regulations in order to carry out any steps spelled out in relevant Russian laws on PD processing."}
      <br />
      <br />
      &nbsp; 6.3.{" "}
      {isRus
        ? "Любой субъект ПДн вправе направить в адрес НИУ ВШЭ отзыв предоставленного им согласия на обработку его ПДн в той же форме, в которой такое согласие от него было получено."
        : "Any PD Subject shall be entitled to withdraw his/her consent provided to HSE for PD processing (in the same format)."}
      <br />
      <br />
      &nbsp; 6.4.{" "}
      {isRus
        ? "Субъект ПДн может осуществлять иные права, предусмотренные законодательством о ПДн."
        : "A PD Subject can exercise his/her other rights as specified by the relevant laws on PD processing."}
      <br />
      <br />
      {isRus ? (
        <div>
          <hr />
          [1] В частности, посредством поисковых запросов, запросов в
          информационно-коммуникационной сети «Интернет», в том числе в
          социальных сетях и пр.
          <br />
          [2] В случае, если она не уникальна, без указания места работы.
          <br />
          [3] В частности, сведения о динамических IP-адресах для
          непрофессионального потребителя услуг связи.
          <br />
          <br />
          Если у Вас остались вопросы, связанные с обработкой персональных
          данных в Университете, вы хотите сообщить о нарушении или отозвать
          свое согласие, Вы можете связаться с нами, заполнив следующую{" "}
          <a href="https://www.hse.ru/expresspolls/poll/12025458.html">форму</a>
          .
        </div>
      ) : null}
    </div>
  );
};

export default PrivacyPolizyText;
